import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { buyers } from '../data/content';
const SHOW_MS = 5200;
const HIDE_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timeout: number;
    const cycle = (show: boolean) => {
      setVisible(show);
      if (!show) setIndex(prev => (prev + 1) % buyers.length);
      timeout = window.setTimeout(() => cycle(!show), show ? SHOW_MS : HIDE_MS);
    };
    timeout = window.setTimeout(() => cycle(true), 6000);
    return () => window.clearTimeout(timeout);
  }, []);
  const buyer = buyers[index];
  const minutes = 2 + index % 7;
  return <div className="pointer-events-none fixed bottom-24 left-3 z-30 w-[min(20rem,calc(100vw-1.5rem))] sm:bottom-28 sm:left-5" data-id="element-35" data-mp="1cxv5sd48jvkf">
      <AnimatePresence data-id="element-36" data-mp="1gy5kce63fuaw">
        {visible ? <motion.div key={index} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-start gap-3 rounded-2xl border border-gold/25 bg-ink-soft/95 p-3 shadow-[0_18px_40px_-18px_rgba(0,0,0,0.9)] backdrop-blur" role="status" data-id="element-37" data-mp="1gwuiwl04eymy">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold/15" data-id="element-38" data-mp="n7n0qa4ebjky">
              <CheckCircle2Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-39" data-mp="ia4tqp9xvefl" />
            </span>
            <div className="min-w-0" data-id="element-40" data-mp="x380s2pwm9s2">
              <p className="text-[13px] font-semibold leading-snug text-cream" data-id="element-41" data-mp="s5olczhgzqyj">
                {buyer.name} · {buyer.country} {buyer.flag}
              </p>
              <p className="text-[12px] leading-snug text-cream/60" data-id="element-42" data-mp="28mkghr0s3r6j">
                Ha appena acquistato Protocollo Clinico Sicuro™
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-gold/80" data-id="element-43" data-mp="2apcq2viiitft">
                {minutes} min fa · Acquisto verificato
              </p>
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}